import 'antd/dist/antd.css';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import DashApp from './dashApp';
import registerServiceWorker from './registerServiceWorker';

ReactDOM.render(<DashApp/>, document.getElementById('root'));

// Hot Module Replacement API
if (module.hot) {
    module.hot.accept('./dashApp', () => {
        const NextApp = require('./dashApp').default;
        ReactDOM.render(<NextApp/>, document.getElementById('root'));
    });
}
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.tsx